import React from 'react';
import './GesetzeSection.css';

const GesetzeSection = () => {
    return (
        <div className="gesetze-section">
            <div className="section-header">
                <h2>Gesetze / Richtlinien</h2>
            </div>

            <div className="gesetze-content">
                <p></p>
            </div>
        </div>
    );
};

export default GesetzeSection;